export default function initQuantitySelector(component, form) {
  if (form) {
    // INIT QUANTITY IF URL HAS A QUANTITY PARAM
    const quantityParameter = getUrlParameter('quantity');
    if (quantityParameter) {
      const input = form.querySelector('input[name="userQuantity"]');
      const max = input.max;
      input.value = Math.min(+quantityParameter, +max);
    }
    import(/* webpackChunkName: "QuantityUpdater" */'./quantitySelectors/_quantity-updater.js').then(module => new module.QuantityUpdater(form)).catch(console.error);

    // INIT STANDARD SELECTOR
    if (form) {
      import(/* webpackChunkName: "Forms" */'./_quantitySelectors.class.js').then(module => {
        new module.QuantitySelector(form);
      }).catch(console.error);
    }
  }
}
function getUrlParameter(param, url = window.location.href) {
  param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
  let results = regex.exec(url);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}